module.exports = __webpack_public_path__ + "static/media/skill_flutter.8c14eccd.jpeg";